import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@mui/material";

const ScreenSizeRestrict = () => {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Dialog
      open={open}
      onClose={() => 0}
      sx={{
        zIndex: 10000,
        "& .MuiDialog-container": {
          backdropFilter: "blur(10px)",
        },
      }}
    >
      <DialogTitle>Warning message</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This website does not support smaller devices. Please use a bigger
          screen device.
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default ScreenSizeRestrict;
